<template>
	<div class="login">
		<div class="text">
			<img src="../../static/image/logo.png" class="logo">
			<span class="logoName">普华维保管理平台</span>
		</div>
		<div class="erCode">
			<img src="../../static/image/eCode.png" class="erCodeImg">
			<div class="erCodeText">扫一扫，下载App</div>
		</div>
		<div class="middleImg middleImg1" v-if="temp">
			<div class="loginFormName loginFormName1">注册账号</div>
			<div class="line"></div>
			<Form :model="formItem" ref='form' class="myForms" >
                <FormItem label="业主单位：">
                    <Select v-model="formItem.bownerId" placeholder="" @on-change="selectowner">
                        <Option v-for="item in ownerList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="所属部门：">
                    <Select v-model="formItem.sysDepartmentId" placeholder="">
                        <Option v-for="item in departmentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
				<FormItem label="真实姓名：">
                    <Input v-model="formItem.name" ></Input>
                </FormItem>
				<FormItem label="手机号码：">
                    <Input v-model="formItem.mobile" ></Input>
                </FormItem>
				<FormItem label="验证码：">
					<Input v-model="formItem.code" class="code" />
                    <div class="sendCode" v-if="tempCode" @click="getCode()">发送验证码</div>
                    <div class="sendCode" v-else disabled>{{text}}s后发送</div>
                </FormItem>
				<FormItem v-if="flag1" label="设置密码：">
					<Input
						type="password"
						v-model="formItem.password"
					/>
					<Icon @click="handlePassword1" class="myPassword1" type="ios-eye-off-outline" />
				</FormItem>
				<FormItem v-else label="设置密码：">
					<Input
						type="text"
						v-model="formItem.password"
					/>
					<Icon @click="handlePassword1" class="myPassword1" type="ios-eye-outline" />
				</FormItem>
				<FormItem v-if="flag2" label="确认密码：">
					<Input
						type="password"
						v-model="formItem.confirmPassword"
					/>
					<Icon @click="handlePassword2" class="myPassword1" type="ios-eye-off-outline" />
				</FormItem>
				<FormItem v-else label="确认密码：">
					<Input
						type="text"
						v-model="formItem.confirmPassword"
					/>
					<Icon @click="handlePassword2" class="myPassword1" type="ios-eye-outline" />
				</FormItem>
				<FormItem label="单位邀请码：">
                    <Input v-model="formItem.authCode" ></Input>
                </FormItem>
            </Form>
			<div class="bottonDiv bottonDiv1" @click="register()">注册</div>
			<div class="toRegister" @click="toRegister(false)">已有账号，去登录→</div>
		</div>
		<div class="middleImg" v-else>
			<div class="loginFormName">欢迎登录</div>
			<div class="line"></div>
			<Input prefix="ios-person" placeholder="用户名" v-model="user" class="myInput" />
			<div v-if="flag">
				<Input
				 	prefix="ios-lock"
					placeholder="密码"
					type="password"
					v-model="password"
					class="myInput myInput1"
				/>
				<Icon @click="handlePassword" class="myPassword" type="ios-eye-off-outline" />
			</div>
			<div v-else>
				<Input
					prefix="ios-lock"
					type="text"
					placeholder="密码"
					class="myInput myInput1"
					v-model="password"
				/>
				<Icon @click="handlePassword" class="myPassword" type="ios-eye-outline" />
			</div>
			<div class="bottonDiv" @click="login()" @keyup.enter.native="login()">登录</div>
			<div class="toRegister" @click="toRegister(true)">还没账号，去注册→</div>
		</div>
	</div>
</template>

<script>
	import url from '../utils/api.js';
	import { Debounce } from '../utils/debounce.js'
	export default {
		name: 'login',
		data () {
			return {
				user: '',
				flag:true,
				flag1:true,
				flag2:true,
				password: '',
				temp:false,
				ownerList:[],
				departmentList:[],
				tempCode:true,
                tempCode1:false,
                text:60,
                total1:60,
				formItem:{
					bownerId:'',
					sysDepartmentId:'',
					name:'',
					mobile:'',
					password:'',
					confirmPassword:'',
					authCode:'',
					code:'',
				}
			}
		},
		created(){
			var _self = this;
			document.onkeydown = function(e){
				if(window.event == undefined){
					var key = e.keyCode;
				}else{
					var key = window.event.keyCode;
				}
				if(key == 13){
					_self.login();
				}
			}
		},
		mounted() {
			this.common.deletes('token');
		},
		methods: {
			handlePassword () {
				this.flag = !this.flag
			},
			handlePassword1 () {
				this.flag1 = !this.flag1
			},
			handlePassword2 () {
				this.flag2 = !this.flag2
			},
			getCode(){
				if (!this.formItem.mobile) {
                    this.$Message.error('手机号不能为空!');
				} else if (!/^1[3456789]\d{9}$/.test(this.formItem.mobile)) {
                    this.$Message.error('手机号格式不正确!');
				} else {
					let arr = {
                        'mobile':this.formItem.mobile
                    }
                    this.$fetch(url.GET_CODE,arr).then(()=>{
                        this.tempCode = false
                        this.tempCode1 = true
                        let clock = window.setInterval(() => {
                            if (this.total1 <= 0) {     //当倒计时小于0时清除定时器
                                window.clearInterval(clock)
                                this.total1 = 61
                                this.tempCode = true
                            }
                            this.total1--
                            this.text = this.total1
                        },1000)
                    }).catch(error => {
						this.common.tokenIsTrue(this,error);
                    });
                }
			},
			register(){
				if(!this.tempCode1){
                    this.$Message.error('未获取验证码!');
                    return
                }
				if(!this.formItem.bownerId){
                    this.$Message.error('业主单位不能为空!');
                    return
                }else if(!this.formItem.sysDepartmentId){
                    this.$Message.error('所属部门不能为空!');
                    return
                }else if(!this.formItem.name){
                    this.$Message.error('真实姓名不能为空!');
                    return
                }else if(!this.formItem.mobile){
                    this.$Message.error('手机号不能为空!');
                    return
                }else if(!this.formItem.code){
                    this.$Message.error('验证码不能为空!');
                    return
                }else if(!this.formItem.password){
                    this.$Message.error('密码不能为空!');
                    return
                }else if(!this.formItem.confirmPassword){
                    this.$Message.error('确认密码不能为空!');
                    return
                }else if(!this.formItem.authCode){
                    this.$Message.error('单位邀请码不能为空!');
                    return
                }
                if(this.formItem.password != this.formItem.confirmPassword){
                    this.$Message.error('两次密码不一致!');
                    return
                }
                let registerReq = {
					'bownerId':this.formItem.bownerId,
					'sysDepartmentId':this.formItem.sysDepartmentId,
					'name':this.formItem.name,
					'mobile':this.formItem.mobile,
					'password':this.formItem.password,
					'confirmPassword':this.formItem.confirmPassword,
					'authCode':this.formItem.authCode,
					'code':this.formItem.code
                }
                this.$post(url.REGISTER, registerReq).then(() => {
                    this.$Message.success('注册成功正为您跳转到登陆!');
                    setTimeout(() => {
                        this.toRegister(false)
                    }, 1000) 
				}).catch(error => {
					this.$Message.error(error.response.data.msg);
				})
			},
			toRegister(value){
				this.temp = value
				if(value){
					this.getOwnerList()
				}else{
					this.formItem.bownerId = '';
					this.formItem.sysDepartmentId = '';
					this.formItem.name = '';
					this.formItem.mobile = '';
					this.formItem.password = '';
					this.formItem.confirmPassword = '';
					this.formItem.authCode = '';
					this.formItem.code = '';
					this.departmentList = [];
					this.tempCode = true;
					this.tempCode1 = false;
					this.text = 60;
					this.total1 = 60;
				}
			},
			selectowner(value){
				this.departmentList = []
				this.formItem.sysDepartmentId = ''
				this.getDepartmentList(value)
			},
			login: Debounce(function (){
				if(this.$route.path&&this.$route.path.length>1){
				}else{
					let arr = {
						'grant_type':'password',
						'username':this.user,
						'password':this.password
					}
					this.common.deletes('token');
					this.common.deletes('expiresin');
					this.common.deletes('reToken');
					this.$fetch(url.LOGIN,arr).then(res=>{
						this.common.set('token', res['access_token']);
						this.common.set('expiresin', res['expires_in']);
						this.common.set('reToken', res['refresh_token']);
						this.GLOBAL.getToken = true
						this.$Message.success('登录成功!');
						this.$router.push({
							path: '/orders'
						});
					}).catch(error => {
						this.$Message.error(error.response.data.msg);
					})
				}
			}, 1000),
			getOwnerList(){
				this.$fetch(url.BOWNER_SELECT).then(res=>{
                    this.ownerList = res
                }).catch(error => {
                    this.common.tokenIsTrue(this,error);
                })
			},
			getDepartmentList(value){
				this.$fetch(url.DEPARTMENT_SELECT,{'ownerId':value}).then(res=>{
                    this.departmentList = res
                }).catch(error => {
                    this.common.tokenIsTrue(this,error);
                })
			}
		}
	}
</script>
<style lang="less">
	::-webkit-scrollbar {
        width: 0px;
        height: 4px;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }
	.middleImg{
		.myInput{
			.ivu-input-inner-container>.ivu-input{
				height: 0.4rem;
			}
			.ivu-input-prefix>.ivu-icon{
				line-height: 0.4rem;
			}
		}
		div>.myInput{
			.ivu-input-inner-container>.ivu-input{
				height: 0.4rem;
			}
			.ivu-input-prefix>.ivu-icon{
				line-height: 0.4rem;
			}
		}
	}

	.middleImg1>.ivu-form>.ivu-form-item{
		margin-bottom: 0.1rem;
		.ivu-form-item-content{
			text-align: left;
			margin-left: 1.2rem;
			.ivu-select{
				width: 2.6rem;
				text-align: left;
				.ivu-select-selection{
					height: 0.36rem;
					div>.ivu-select-selected-value{
						line-height: 0.36rem;
					}
				}
			}
			.ivu-input-wrapper{
				width: 2.6rem;
				text-align: left;
				.ivu-input-inner-container>.ivu-input{
					height: 0.36rem;
					line-height: 0.36rem;
				}
			}
			.code{
				width: 1.6rem;
			}
		}
		.ivu-form-item-label{
			height:0.36rem;
			line-height: 0.2rem;
			width: 1.2rem;
			font-size: 0.14rem;
		}
	}
</style>
<style scoped lang="less">
	@color:rgba(241, 230, 230,0);
	@left:left;
	@inline_b:inline-block;
	@img:'../../static/image/';
	@blue:#45c8dc;
	.login{
		width: 100%;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		background-color: #fff;
		background-image: url("@{img}loginBg.png");
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 50%;
		overflow: hidden;
		border-top: 1px solid transparent;
		border-color: @color;
	}
	.text{
		width: 6.66rem;
		height: 0.45rem;
		font-family: SourceHanSansCN-Medium;
		font-size:0.26rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.45rem;
		letter-spacing: 0px;
		color: #ffffff;
		margin: 0.6rem 0 0 0.6rem;
	}
	.logo{
		width: 0.78rem;
		height: 0.45rem;
		display: @inline_b;
		vertical-align:middle;
	}
	.logoName{
		display: @inline_b;
		margin-left: 0.18rem;
	}
	.middleImg{
		width: 3.6rem;
		height: 3.8rem;
		background-color: #ffffff;
		border-radius: 0.04rem;
		position: absolute;
		top:3rem;
		right: 3.41rem;
	}
	.middleImg1{
		width: 4.3rem;
		height: 5.9rem;
		position: absolute;
		top: 1.7rem;
		right: 3.71rem;
	}
	.loginFormName{
		width: auto;
		height: 0.2rem;
		font-family: MicrosoftYaHei-Bold;
		font-size: 0.2rem;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #44475d;
		margin-top:0.5rem;
	}
	.loginFormName1{
		margin-top:0.3rem;
	}
	.line{
		width: 0.8rem;
		height: 0.03rem;
		background-color: #35cadc;
		margin: 0.08rem auto 0 auto;
	}
	.myInput{
		width: 2.6rem;
		height: 0.4rem;
		margin: 0.38rem auto 0 auto;
	}
	.myInput1{
		margin: 0.2rem auto 0 auto;
	}
	.bottonDiv{
		width: 2.6rem;
		height: 0.4rem;
		background-color: #35cadc;
		border-radius: 0.04rem;
		margin: 0.4rem auto 0 auto;
		font-family: MicrosoftYaHei-Bold;
		font-size: 0.16rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.4rem;
		letter-spacing: 0px;
		color: #ffffff;
		cursor:pointer;
	}
	.bottonDiv1{
		margin: 0.3rem auto 0 auto;
	}
	.erCode{
		width:1.4rem;
		height:1.8rem;
		position: absolute;
		border-radius:0.02rem 0.02rem 0 0;
		top: 4rem;
		left: 6.5rem;
	}
	.erCodeImg{
		width:1.4rem;
		height:1.4rem;
	}
	.erCodeText{
		margin-top: -0.1rem;
		width:1.4rem;
		height:0.4rem;
		font-family: SourceHanSansCN-Regular;
		font-size: 0.14rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.4rem;
		border-radius:0 0 0.02rem 0.02rem;
		color: #ffffff;
		background:#35cadc;
	}
	.toRegister{
		margin-top: 0.22rem;
		font-family: MicrosoftYaHei;
		font-size: 0.14rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.14rem;
		letter-spacing: 0px;
		color: #858693;
		cursor:pointer;
	}
	.myForms{
		margin-top:0.3rem;
	}
	.sendCode{
        display: inline-block;
        text-align: center;
        width: 0.9rem;
        height: 0.34rem;
        background-color: #ffffff;
        border-radius: 0.04rem;
        border: solid 1px #0ccec3;
        font-family: MicrosoftYaHei;
        font-size: 0.14rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.34rem;
        color: #0ccec3;
        cursor: pointer;
    }
	.myPassword{
		position: absolute;
		right: 0.6rem;
		top: 1.9rem;
		font-size:0.2rem;
		cursor: pointer;
	}
	.myPassword1{
		cursor: pointer;
		font-size:0.2rem;
		position: relative;
    	right: 0.3rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue